// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-button {
  --background: transparent;
  color: var(--ion-color-primary);
  --border-color: var(--ion-color-primary);
  --border-width: 2px;
  --border-style: solid;
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 0px !important;
  border-bottom: 1.2px solid #857761;
}

.forgot-password {
  margin: 20px 0;
  font-weight: bold;
  color: var(--ion-color-primary);
  cursor: pointer;
  font-size: 14px;
}

.wrapper {
  padding: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-in/sign-in.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,+BAAA;EACA,wCAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AACA;EACE,8BAAA;EACA,kCAAA;AAEF;;AACA;EACE,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;AAEF;;AAAA;EACE,aAAA;AAGF","sourcesContent":[".sign-up-button {\n  --background: transparent;\n  color: var(--ion-color-primary);\n  --border-color: var(--ion-color-primary);\n  --border-width: 2px;\n  --border-style: solid;\n}\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\nion-item {\n  --border-width: 0px !important;\n  border-bottom: 1.2px solid #857761;\n}\n\n.forgot-password {\n  margin: 20px 0;\n  font-weight: bold;\n  color: var(--ion-color-primary);\n  cursor: pointer;\n  font-size: 14px;\n}\n.wrapper{\n  padding: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
